import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';

import vueJsonp from 'vue-jsonp'
Vue.use(vueJsonp)

import "element-ui/lib/theme-chalk/index.css";
import elementEnlocale from 'element-ui/lib/locale/lang/en';
import elementZhlocale from 'element-ui/lib/locale/lang/zh-CN';

Vue.use(VueI18n)
let zh = require('@js/language/zh.js')
let en = require('@js/language/en.js')

let messages = {
    zh: {
        ...zh,
        ...elementZhlocale
    },
    en: {
        ...en,
        ...elementEnlocale
    }
}

const i18n = new VueI18n({
    locale: sessionStorage.getItem("language") || 'zh',
    messages
})

Vue.use(ElementUI, {
    size: 'medium',
    i18n: (key, value) => i18n.t(key, value)
})

import baseElement from '@components/element';
Object.keys(baseElement).forEach(key => Vue.component(key, baseElement[key]))

import '@/assets/css/common.less'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')